/**
 * Visibility for the contextual tool rail. Mode is always shown; mesh
 * element and face-tool clusters swap in rather than stacking a mega-toolbar.
 */
export function editorChromeState({ meshEditActive = false, elementType = 'vertex' } = {}) {
  const editing = Boolean(meshEditActive);
  return {
    editorMode: editing ? 'mesh' : 'object',
    showMeshElements: editing,
    showEdgeTools: editing && elementType === 'edge',
    showFaceTools: editing && elementType === 'face',
  };
}

export function editorModeLabel({ meshEditActive = false, elementType = 'vertex' } = {}) {
  if (!meshEditActive) return 'Object';
  const type = String(elementType);
  return `Edit · ${type.charAt(0).toUpperCase()}${type.slice(1)}`;
}
